//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.service('ContentLibraryItemDetailsService', [
    'ContentLibraryApiService',
    'rx',
    function(
            ContentLibraryApiService,
            rx,
        ) {
      const GET_ITEM_DETAILS_BATCH_DELAY = 100;
      const MAX_ITEM_DETAILS_PARTITION_SIZE = 30;
      let requestingItemDetails = false;

      const cachedItemDetails = {};
      let itemDetailsRequestQueue = [];

            // Streams item details metadata as a map from partial universal item ID to content item details object
      const itemDetailsStream = new rx.BehaviorSubject();

      const requestQueuedItemDetailsFromServerRecursive = function() {
        if (_(itemDetailsRequestQueue).isEmpty() || requestingItemDetails) {
          return;
        }

        const requestedPartialUniversalItemIds = _(itemDetailsRequestQueue).first(MAX_ITEM_DETAILS_PARTITION_SIZE);
        itemDetailsRequestQueue = _(itemDetailsRequestQueue).rest(MAX_ITEM_DETAILS_PARTITION_SIZE);

        requestingItemDetails = true;
        ContentLibraryApiService.getItemDetailsAsync(requestedPartialUniversalItemIds).then((deetsMetadataByPartialUid) => {
          _(requestedPartialUniversalItemIds).each((item) => {
            cachedItemDetails[item] = deetsMetadataByPartialUid[item];
          });

          itemDetailsStream.next(cachedItemDetails);
        }).finally(() => {
          requestingItemDetails = false;
          requestQueuedItemDetailsFromServerRecursive();
        });
      };

      const requestQueuedItemDetailsFromServerDebounce = _.debounce(() => {
        requestQueuedItemDetailsFromServerRecursive();
      }, GET_ITEM_DETAILS_BATCH_DELAY);

            /**
             * Queues a request for an items metadata details, which will be published to the itemDetailsStream when the back end responds
             * If the item exists in the local cache, an additional request will not be queued unless forceRefresh is true
             * Returns the item details stream, which streams item details metadata as a map from partial universal item ID to content item details object
             */
      this.requestItemDetails = function(partialUniversalItemId, forceRefresh) {
        const currentDeetsMetadata = cachedItemDetails[partialUniversalItemId];
        if (currentDeetsMetadata && !forceRefresh) {
          return itemDetailsStream;
        }

        itemDetailsRequestQueue.push(partialUniversalItemId);

        requestQueuedItemDetailsFromServerDebounce();

        return itemDetailsStream;
      };
    },
  ]);
})();
